module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-card', {
    attrs: {
      "id": "activity-input"
    }
  }, [_c('mu-card-text', {
    staticClass: "card-style"
  }, [(_vm.loading === true) ? _c('div', [_c('mu-flexbox', {
    staticClass: "card-loading-padding",
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 56,
      "color": "#FFFFFF",
      "strokeWidth": 5
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.loading && _vm.data.error) ? _c('mu-flexbox', {
    staticClass: "card-error-padding",
    attrs: {
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "card-notice-title",
    domProps: {
      "textContent": _vm._s(_vm.$t('message.cardEmpty'))
    }
  }), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.$t('message.cardTapPrefix')) + "\n          "), (_vm.data.no_setting) ? _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "settings"
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.data.error) ? _c('mu-icon', {
    staticClass: "card-icon-error",
    attrs: {
      "slot": "left",
      "size": 16,
      "value": "add"
    },
    slot: "left"
  }) : _vm._e(), _vm._v(" "), (_vm.data.error || _vm.data.no_setting) ? _c('span', [_vm._v(_vm._s(_vm.$t('message.cardTapSuffix')))]) : _vm._e()], 1)])], 1) : _vm._e(), _vm._v(" "), (!_vm.loading && !_vm.data.error) ? _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.goToDetail
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }]
  }, [_vm._v(_vm._s(_vm.hasData = true))]), _vm._v(" "), (_vm.hasStepsAndNoSelfReportedReadings || _vm.isStepsMoreRecent) ? _c('div', [_c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('message.labelTotalSteps')) + "\n              ")]), _vm._v(" "), _c('mu-flexbox-item', [_c('div', {
    staticClass: "card-large-stat",
    attrs: {
      "align": "right"
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.formatNumber(_vm.data.steps.steps))
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip.top",
      value: ('Todays estimated steps'),
      expression: "'Todays estimated steps'",
      modifiers: {
        "top": true
      }
    }],
    staticStyle: {
      "margin-left": "-3px"
    },
    domProps: {
      "textContent": _vm._s('/' + _vm.formatNumber(_vm.data.steps.predictions.steps))
    }
  })])])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('message.labelFromDevice')) + "\n              ")]), _vm._v(" "), _c('mu-flexbox-item', [_c('div', {
    staticClass: "card-large-stat",
    attrs: {
      "align": "right"
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.deviceName)
    }
  })])])], 1)], 1), _vm._v(" "), (_vm.data.steps.distance_mi !== null) ? _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('message.labelDistance')) + "\n              ")]), _vm._v(" "), _c('mu-flexbox-item', [_c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.data.steps.distance_mi.toFixed(2) + ' mi')
    }
  })])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('message.labelFloorsClimbed')) + "\n              ")]), _vm._v(" "), _c('mu-flexbox-item', [_c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.data.steps.floors)
    }
  })])])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('message.labelCaloriesBurnt')) + "\n              ")]), _vm._v(" "), _c('mu-flexbox-item', [_c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.formatNumber(_vm.data.steps.calories) + ' kcal')
    }
  })])])], 1)], 1)], 1) : _c('div', [_c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('message.labelActivity')) + "\n              ")]), _vm._v(" "), _c('mu-flexbox-item', [_c('div', {
    staticClass: "card-large-stat",
    attrs: {
      "align": "right"
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.getLocaleLabel(_vm.data.type))
    }
  })])])], 1)], 1), _vm._v(" "), _c('mu-content-block', [_c('mu-flexbox', [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('message.labelDuration')) + "\n              ")]), _vm._v(" "), _c('mu-flexbox-item', [_c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.data.minutes + ' mins')
    }
  })])])], 1)], 1), _vm._v(" "), _c('mu-content-block', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-flexbox', {
    attrs: {
      "orient": "horizontal",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    staticClass: "card-lite-title"
  }, [_vm._v("\n                " + _vm._s(_vm.$t('message.labelCaloriesBurnt')) + "\n              ")]), _vm._v(" "), _c('mu-flexbox-item', [_c('div', {
    attrs: {
      "align": "right"
    }
  }, [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.data.calories_burnt + ' kcal')
    }
  })])])], 1)], 1)], 1)])]) : _vm._e()], 1), _vm._v(" "), _c('mu-card-actions', [_c('mu-flexbox', {
    staticStyle: {
      "height": "48px"
    },
    attrs: {
      "justify": "flex_start"
    }
  }, [_c('mu-icon', {
    staticClass: "card-left-icon",
    attrs: {
      "value": "directions_walk"
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    staticClass: "left16",
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "align": "right"
    }
  }, [_c('mu-icon-button', {
    staticClass: "card-bar-icon",
    attrs: {
      "disabled": _vm.loading,
      "icon": _vm.isOpenInput ? 'remove' : 'add'
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggle.apply(null, arguments)
      }
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "css": false
    },
    on: {
      "enter": _vm.onToggleEnter,
      "leave": _vm.onToggleLeave
    }
  }, [(_vm.isOpenInput) ? _c('form', {
    staticStyle: {
      "overflow": "hidden"
    },
    style: ({
      height: _vm.computedAuto
    }),
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveReading.apply(null, arguments)
      }
    }
  }, [_c('mu-card-text', [_c('mu-select-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required',
      "data-vv-name": "activityType",
      "data-vv-as": _vm.$t('message.labelActivityType'),
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('activityType'),
      "label": _vm.$t('message.labelActivityType'),
      "hint-text": _vm.$t('message.selectText'),
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.type),
      callback: function($$v) {
        _vm.$set(_vm.model, "type", $$v)
      },
      expression: "model.type"
    }
  }, _vm._l((_vm.activityTypes), function(item, index) {
    return _c('mu-menu-item', {
      key: 'activity-' + index,
      attrs: {
        "title": _vm.getLocaleLabel(item.value),
        "value": item.value
      }
    })
  }), 1), _vm._v(" "), _c('mu-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate"
    }],
    attrs: {
      "data-vv-validate-on": "none",
      "data-vv-rules": 'required',
      "data-vv-name": "duration",
      "data-vv-as": _vm.$t('message.labelDurationMinutes'),
      "data-vv-value-path": "inputValue",
      "errorText": _vm.errors.first('duration'),
      "hintText": _vm.$t('message.placeholderText'),
      "label": _vm.$t('message.labelDurationMinutes'),
      "type": "number",
      "fullWidth": ""
    },
    model: {
      value: (_vm.model.minutes),
      callback: function($$v) {
        _vm.$set(_vm.model, "minutes", $$v)
      },
      expression: "model.minutes"
    }
  }), _vm._v(" "), _c('mu-checkbox', {
    attrs: {
      "label": _vm.$t('message.labelCustomDate')
    },
    model: {
      value: (_vm.model.customDate),
      callback: function($$v) {
        _vm.$set(_vm.model, "customDate", $$v)
      },
      expression: "model.customDate"
    }
  }), _vm._v(" "), (_vm.model.customDate) ? _c('date-picker', {
    attrs: {
      "type": "datetime"
    },
    model: {
      value: (_vm.model.date),
      callback: function($$v) {
        _vm.$set(_vm.model, "date", $$v)
      },
      expression: "model.date"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }), _vm._v(" "), _c('alert', {
    attrs: {
      "type": "info",
      "icon": "directions_walk"
    }
  }, [_c('div', {
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('message.labelCalorieBurn')) + " " + _vm._s(_vm.calorieBurn) + "kcal\n          ")])])], 1), _vm._v(" "), _c('mu-card-actions', {
    attrs: {
      "align": "right"
    }
  }, [_c('button', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "submit"
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "label": _vm.$t('message.discardText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.closeInput.apply(null, arguments)
      }
    }
  }), _vm._v(" "), _c('mu-flat-button', {
    staticClass: "demo-flat-button",
    attrs: {
      "type": "button",
      "disabled": _vm.isSaving,
      "label": _vm.isSaving ? _vm.$t('message.savingText') : _vm.$t('message.saveText')
    },
    nativeOn: {
      "click": function($event) {
        return _vm.saveReading.apply(null, arguments)
      }
    }
  })], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-add88658","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Tracking/Input/Activity/Activity.vue
// module id = 3276
// module chunks = 1